import React, { FC } from 'react'

import { Box } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import Flexbox from '~/components/shared/Flexbox'
import Text from '~/components/shared/Text'

interface PossibilityProps {
  text: string
  maxWidthText?: number
}

const Possibility: FC<PossibilityProps> = ({ text, maxWidthText }) => {
  return (
    <Flexbox
      p={1.5}
      mt={3}
      mx={1.5}
      minWidth={300}
      border="1px solid"
      borderColor="primary.main"
      borderRadius="4px"
    >
      <Box alignSelf="center" mt={0.5}>
        <CheckCircleIcon color="primary" />
      </Box>

      <Box maxWidth={maxWidthText || 250} alignSelf="center">
        <Text ml={1.5}>{text}</Text>
      </Box>
    </Flexbox>
  )
}

export default Possibility
